import axios from '@/axios';

const RESOURCE_NAME = '/startup/team';

export default {
    getUsersIndex(search) {
        return axios.get(`${RESOURCE_NAME}/get-users-index?search=${search}`)
    },

    getUserEdit(id) {
        return axios.get(`${RESOURCE_NAME}/get-user-edit?id=${id}`)
    },

    saveUser(id, data) {
        return axios.post(`${RESOURCE_NAME}/save-user?id=${id}`, data)
    },

    deleteUser(id) {
        return axios.post(`${RESOURCE_NAME}/delete-user?id=${id}`)
    },

    sendActivationEmail(id) {
        return axios.post(`${RESOURCE_NAME}/send-activation-email?id=${id}`)
    },
}
